import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Configuration } from '../configuration';
import { IApplicant } from '../model/IApplicant';
import { IGuardian } from '../model/IGuardian';
import { IUser } from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class CookiesLocalService {

  getApplicantProgrammeOfChoice() {

      return JSON.parse(localStorage.getItem(Configuration.localStorageData.applicantProgrammeOfChoice));
    }

  getRefreshedApplicantProgrammeOfChoice(model) {
    localStorage.setItem(Configuration.localStorageData.applicantProgrammeOfChoice, JSON.stringify(model));
    return this.getApplicantProgrammeOfChoice();
  }



  getApplicantExamination() {

    return JSON.parse(localStorage.getItem(Configuration.localStorageData.applicantExaminationData));
  }

getRefreshedApplicantExamination(model) {
  localStorage.setItem(Configuration.localStorageData.applicantExaminationData, JSON.stringify(model));
  return this.getApplicantExamination();
}



constructor(private cookieService: CookieService) { }


  getApplicantData(): IApplicant {
      return JSON.parse(localStorage.getItem(Configuration.localStorageData.applicaintData));
    }

   getRefreshedApplicantData(model): IApplicant {
     localStorage.setItem(Configuration.localStorageData.applicaintData, JSON.stringify(model));
    return this.getApplicantData();


  }
  getProgressMessageData() {
    return JSON.parse(localStorage.getItem(Configuration.localStorageData.progressMessageData));
  }

  getRefreshedProgressMessageData(model): IApplicant {

    localStorage.setItem(Configuration.localStorageData.progressMessageData, JSON.stringify(model));
    return this.getApplicantData();


  }


  getGuardianData(): IGuardian {
       return JSON.parse(localStorage.getItem(Configuration.localStorageData.guardianData));
  }

  getRefreshedGuardianData(model): IGuardian {


    localStorage.setItem(Configuration.localStorageData.guardianData, JSON.stringify(model));
    return this.getGuardianData();


  }


  getLoginUserData() {
    if (this.cookieService.check(Configuration.localStorageData.loginUserData)) {
       return JSON.parse(this.cookieService.get(Configuration.localStorageData.loginUserData));
    }
  }



  getRefreshedLoginUserData(model): IUser {
    this.cookieService.set(Configuration.localStorageData.loginUserData, JSON.stringify(model));
    return this.getLoginUserData();


  }

  getUserToken() {
    return localStorage.getItem(Configuration.localStorageData.token);
  }

  getUserCampus() {
    return localStorage.getItem(Configuration.localStorageData.campusId);
  }


  getRefreshedUserToken(token): string {
    localStorage.setItem(Configuration.localStorageData.token, token);
    return this.getUserToken();
  }

  removeUserToken() {
    localStorage.removeItem(Configuration.localStorageData.token);
  }








}
